<!-- Top Bar -->
<div class="amt-topbar">
    <div class="amt-container">
        <div class="topbar-left">
            <a href="tel:+919513266444"><i class="fas fa-phone-alt"></i> +91 95132 66444</a>
            <a href="mailto:aathreyamachinetools@gmail.com"><i class="fas fa-envelope"></i>
                aathreyamachinetools&#64;gmail.com</a>
        </div>
        <div class="topbar-right">
            <a href="#"><i class="fab fa-facebook-f"></i></a>
            <a href="#"><i class="fab fa-instagram"></i></a>
            <a href="#"><i class="fab fa-linkedin-in"></i></a>
            <a href="#"><i class="fab fa-whatsapp"></i></a>
            <a routerLink="/login" class="topbar-login">
                <i class="fas fa-sign-in-alt"></i>
            </a>
        </div>
    </div>
</div>

<!-- Main Navbar -->
<nav class="amt-navbar" [class.scrolled]="isScrolled" [class.mobile-open]="isMobileMenuOpen">
    <div class="amt-container">
        <a class="navbar-brand" routerLink="/home">
            <img src="assets/img/AMT.png" alt="Aathreya Machine Tools" class="brand-logo">
        </a>

        <button class="mobile-toggle" (click)="toggleMobileMenu()">
            <span [class.open]="isMobileMenuOpen"></span>
        </button>

        <div class="navbar-menu" [class.active]="isMobileMenuOpen">
            <a routerLink="/home" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}"
                (click)="closeMobileMenu()">
                <i class="fas fa-home"></i> Home
            </a>
            <a routerLink="/about" routerLinkActive="active" (click)="closeMobileMenu()">
                <i class="fas fa-info-circle"></i> About Us
            </a>

            <!-- Products Dropdown -->
            <div class="dropdown" (mouseenter)="showDropdown = true" (mouseleave)="showDropdown = false">
                <a routerLink="/products" routerLinkActive="active" class="dropdown-trigger"
                    (click)="closeMobileMenu()">
                    <i class="fas fa-tools"></i> Products <i class="fas fa-chevron-down dropdown-arrow"></i>
                </a>
                <div class="dropdown-menu" [class.show]="showDropdown">
                    <a *ngFor="let cat of categories" [routerLink]="['/products']"
                        [queryParams]="{category: cat.categoryId}" (click)="showDropdown = false; closeMobileMenu()">
                        <i class="fas fa-angle-right"></i> {{ cat.categoryName }}
                    </a>
                </div>
            </div>

            <a routerLink="/contact" routerLinkActive="active" (click)="closeMobileMenu()">
                <i class="fas fa-phone-square-alt"></i> Contact
            </a>
        </div>
    </div>
</nav>